import { ONLINE_VOTING_TEMPLATE_IDS } from './constants';

export const createHandleInputChange = (options) => (field, value) => {
    const {
        user,
        formData,
        setFormData,
        setErrors,
        buildingsData,
        validateSendingOptionWithSendToOptions,
        validateCustomRecipients,
        updateBuildingSelectionsFromLots,
        setChannelInput,
        setIsDefaultChannel,
        setAllInboxes,
        setAllChannels,
        setEmailSignatures,
        setShowSignatureSelect,
        setShowEmailField,
        UserInboxes,
        UserChannels,
        excludedEmails,
        userEmailSignatures,
        setDefaultChannel,
        setMeetingInput,
        setMeetingSuggestions,
        setShowMeetingSuggestions,
        setSelectedMeetingSuggestionIndex,
        setShowReminderDate,
        setWorkflowRuns,
        setWorkflowRunInput,
        setPlanNumberSuggestions,
        setShowPlanSuggestions,
        setProcessStreetFormFields,
        setEventDateSource,
    } = options;

    console.log(field, value);
    const userEmail = user?.email || user?.username;

    if (field === 'sendTo') {
        const smata_config_id = formData.smata_config_id;
        const send_to = value;
        const lotsUserTypes = formData.lotsUserTypes;
        validateSendingOptionWithSendToOptions(smata_config_id, send_to, lotsUserTypes);
        validateCustomRecipients(formData.customRecipients, value, lotsUserTypes, setErrors);

        if (value === 'committeeMembers') {
            setFormData(prevData => ({ ...prevData, customRecipients: [] }));
            setErrors(prev => ({
                ...prev,
                customRecipientsValidation: false,
                customRecipientsValidationMessage: ''
            }));
        }
    }

    if (field === 'sending') {
        setFormData(prevData => ({ ...prevData, [field]: value }));
    } else if (field === 'sendingOption') {
        setChannelInput('');
        setIsDefaultChannel(false);
        setErrors(prev => ({
            ...prev,
            channel: false,
            channelSuggestion: false
        }));
        if (value === 'sending-from-other') {
            setAllInboxes([]);
            setAllChannels([]);
            setEmailSignatures([]);
            setShowSignatureSelect(false);
            setFormData(prevData => ({ ...prevData, email: '', inbox_id: '', channel_id: '', channel_send_as: '', signature_id: '' }));
            setShowEmailField(true);
            setFormData(prevData => ({ ...prevData, [field]: value }));
        } else {
            setAllInboxes(UserInboxes);
            setAllChannels(UserChannels);
            setDefaultChannel(UserChannels);

            const isUserEmailExcluded = excludedEmails.some(excludedEmail =>
                excludedEmail.email && excludedEmail.email.toLowerCase() === userEmail.toLowerCase()
            );

            if (isUserEmailExcluded && userEmailSignatures && userEmailSignatures.length > 1) {
                setShowSignatureSelect(true);
                setFormData(prevData => ({ ...prevData, email: userEmail, inbox_id: '', channel_id: '', channel_send_as: '', signature_id: '' }));
            } else {
                setShowSignatureSelect(false);
                setFormData(prevData => ({ ...prevData, email: userEmail, inbox_id: '', channel_id: '', channel_send_as: '', signature_id: '' }));
            }
            setShowEmailField(false);
            setFormData(prevData => ({ ...prevData, [field]: value }));
        }
    } else if (field === 'issueType') {
        setMeetingInput('');
        setMeetingSuggestions([]);
        setShowMeetingSuggestions(false);
        setSelectedMeetingSuggestionIndex(-1);
        setFormData(prevData => ({
            ...prevData,
            [field]: value,
            selectedMeetingId: null,
            online_voting_open_for_voting: null,
            online_voting_show_on_portal: null,
            mergeFieldsData: { ...prevData.mergeFieldsData, event: '' }
        }));
        setEventDateSource?.(null);
        return;
    } else if (field === 'sendReminders') {
        if (value === 'yes') {
            setShowReminderDate(true);
            setFormData(prevData => {
                let autoReminderDate = prevData.reminderDate;
                if (prevData.issueType === 'notices' && prevData.selectedMeetingId && prevData.mergeFieldsData?.event) {
                    const meetingDate = new Date(prevData.mergeFieldsData.event);
                    const reminderDate = new Date(meetingDate);
                    const daysBefore = ONLINE_VOTING_TEMPLATE_IDS.includes(Number(prevData.smata_config_id)) ? 2 : 1;
                    reminderDate.setDate(reminderDate.getDate() - daysBefore);
                    reminderDate.setHours(10, 0, 0, 0);
                    autoReminderDate = reminderDate.toString();
                }
                return { ...prevData, [field]: value, reminderDate: autoReminderDate };
            });
        } else {
            setShowReminderDate(false);
            setFormData(prevData => ({ ...prevData, [field]: value }));
        }
    } else if (field === 'lotsUserTypes' || field === 'selectedLots') {
        setFormData(prevData => {
            const currentValue = prevData[field] || [];
            const newValue = Array.isArray(currentValue)
                ? currentValue.includes(value)
                    ? currentValue.filter(v => v !== value)
                    : [...new Set([...currentValue, value])]
                : [value];

            if (field === 'lotsUserTypes') {
                const smata_config_id = prevData.smata_config_id;
                const send_to = prevData.sendTo;
                const lotsUserTypes = newValue;
                validateSendingOptionWithSendToOptions(smata_config_id, send_to, lotsUserTypes);
                validateCustomRecipients(prevData.customRecipients, send_to, lotsUserTypes, setErrors);
            }

            if (field === 'selectedLots' && buildingsData?.buildings) {
                updateBuildingSelectionsFromLots(newValue);
            }

            return { ...prevData, [field]: newValue };
        });
    } else if (field === 'sending_preference') {
        setFormData(prevData => ({
            ...prevData,
            sending_preference: prevData.sending_preference === value ? '' : value
        }));
    } else if (field === 'lotsSelectionType') {
        setFormData(prevData => ({
            ...prevData,
            lotsSelectionType: value,
            lots_sprated: '',
            lotRangeStart: '',
            lotRangeEnd: '',
            selectedLots: []
        }));
        setErrors(prev => ({
            ...prev,
            lots_sprated: false,
            lotRangeStart: false,
            lotRangeEnd: false,
            selectedLots: false
        }));
        return;
    }
    else if (field === 'custom_document_name') {
        const hasSpecialChars = /[^a-zA-Z0-9 ]/.test(value);
        let sanitizedValue = value
            .replace(/[^a-zA-Z0-9 ]+/g, '')
            .replace(/\s+/g, ' ');

        setFormData(prevData => ({ ...prevData, [field]: sanitizedValue }));
        setErrors(prev => ({ ...prev, custom_document_name: hasSpecialChars }));
        return;
    } else if (field === 'eventDateTime') {
        setFormData(prevData => ({ ...prevData, [field]: value }));
        setErrors(prev => ({
            ...prev,
            event_date: false,
            event_time: false
        }));
    } else if (field === 'windowLockApproval') {
        let contractorName = '';
        if (value === 'yes_qsec') {
            contractorName = 'Qsec';
        } else if (value === 'yes') {
            contractorName = '';
        } else {
            contractorName = '';
        }

        setFormData(prevData => ({
            ...prevData,
            [field]: value,
            contractorName: contractorName,
            windowLockProceedWith: value === 'no' ? '' : prevData.windowLockProceedWith,
            windowLockSpecialRequests: value === 'no' ? '' : prevData.windowLockSpecialRequests
        }));
    } else if (field === 'preload_from_process_street') {
        if (value) {
            setFormData(prevData => ({
                ...prevData,
                [field]: value,
                planNumber: '',
                databaseName: '',
                branch_id: '',
                buildingAddress: ''
            }));
            setWorkflowRuns([]);
            setWorkflowRunInput('');
            setPlanNumberSuggestions([]);
            setShowPlanSuggestions(false);
        } else {
            setFormData(prevData => ({
                ...prevData,
                [field]: value,
                process_street_workflow_run: '',
                meetingLocation: '',
                mergeFieldsData: { ...prevData.mergeFieldsData, event: '', meeting_location: '' }
            }));
            setWorkflowRuns([]);
            setWorkflowRunInput('');
            setProcessStreetFormFields(null);
            setEventDateSource?.(null);
        }
    } else if (field === 'process_street_workflow_run') {
        setFormData(prevData => ({ ...prevData, [field]: value }));
        setErrors(prev => ({
            ...prev,
            [field]: false
        }));
    } else if (field === 'customRecipients') {
        setFormData(prevData => ({ ...prevData, [field]: value }));
        validateCustomRecipients(value, formData.sendTo, formData.lotsUserTypes, setErrors);
    } else {
        setFormData(prevData => {
            const newData = { ...prevData, [field]: value };
            return newData;
        });
    }

    // Clear error for this field if it was previously marked as error
    setErrors(prev => {
        if (prev[field]) {
            return { ...prev, [field]: false };
        }
        return prev;
    });
};
